import baseAPI from '@/api/base';
import {
  GetKabbalahDesign_N,
  SaveKabbalahDesign_N,
} from '@/dtos/kabbalah_design_N.dto';
import {
  GET_KABBALAH_DESIGN_N_URL,
  SAVE_KABBALAH_DESIGN_N_URL,
  UPLOAD_KABBALAH_DESIGN_IMAGE_N_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class KabbalahDesign_N {
  static getKabbalahDesign_N = async (
    getKabbalahDesign_N: GetKabbalahDesign_N
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_KABBALAH_DESIGN_N_URL, {
      params: getKabbalahDesign_N,
    });
    return response;
  };

  static saveKabbalahDesign_N = async (
    saveKabbalahDesign_N: SaveKabbalahDesign_N
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(
      SAVE_KABBALAH_DESIGN_N_URL,
      {
        ...saveKabbalahDesign_N,
      }
    );
    return response;
  };

  // Uploaded on its own, ahead of the design being saved, so the stored HTML
  // only ever carries a URL rather than an inlined file.
  static uploadKabbalahDesignImage_N = async (
    formData: FormData
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(
      UPLOAD_KABBALAH_DESIGN_IMAGE_N_URL,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response;
  };
}

export default KabbalahDesign_N;
